import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = ({ selectedRole, onRoleChange }) => {
  const roles = [
    {
      id: 'dentist',
      label: 'Dentist',
      icon: 'Stethoscope',
      description: 'General & specialist dentists'
    },
    {
      id: 'hygienist',
      label: 'Hygienist',
      icon: 'Heart',
      description: 'Dental hygienists & assistants'
    },
    {
      id: 'admin',
      label: 'Administrative',
      icon: 'Users',
      description: 'Front desk & billing'
    }
  ];

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-foreground">
        Select Your Role
      </label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {roles?.map((role) => (
          <button
            key={role?.id}
            type="button"
            onClick={() => onRoleChange(role?.id)}
            className={`flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-smooth ${
              selectedRole === role?.id
                ? 'border-primary bg-primary/10' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${
              selectedRole === role?.id ? 'bg-primary/20' : 'bg-muted'
            }`}>
              <Icon 
                name={role?.icon} 
                size={24} 
                color={selectedRole === role?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
              />
            </div>
            <div className="text-center">
              <p className={`text-sm font-semibold ${
                selectedRole === role?.id ? 'text-primary' : 'text-foreground'
              }`}>
                {role?.label}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {role?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;